var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('paginated-browser',{ref:"browserSpp",attrs:{"data-callback":_vm.getSpp},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var data = ref.data;
return [_c('table-spp',{attrs:{"items":data},on:{"delete":_vm.deleteSpp}})]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb682d88","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/BrowseSpp.vue
// module id = null
// module chunks = 